import './text.scss';

import PubSub from 'pubsub-js';
import { load } from 'recaptcha-v3';
import { PageEvents } from './page';

const COMPONENT_NAME = 'text';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Text)
 */
export class Text {
  constructor($container = $('body')) {
    const self = this;

    // find elements
    this._els = {};
    this._els.container = $container;
    this._els.text = this._els.container.find(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.text.each(function () {
        self._initFormFocus($(this));
        self._initSingleInstance($(this));
        self._inputFileLoad($(this));
        self._initRecaptcha($(this));
      });
    });
  }

  // private methods
  _initRecaptcha($instanceEl) {
    const captchaKey = window.recaptchaKey;
    const $form = $instanceEl.find('#formModalContact');

    if (captchaKey) {
      load(captchaKey, { autoHideBadge: true }).then((recaptcha) => {
        $form.on('submit', (event) => {
          event.preventDefault();

          $form.find('.btn.btn-primary').attr('disabled', true);
          setTimeout(() => {
            $form.find('.btn.btn-primary').attr('disabled', false);
          }, 3000);

          // inizializza il recaptcha
          const formName = $form.attr('name');
          recaptcha.execute(captchaKey, { action: `${formName}_submit` }).then((token) => {
            // estraggo i dati dal form salvandoli come json
            const formMethod = $form.attr('method');
            const formData = new FormData($('#formModalContact')[0]);

            // Invio il form tramite richiesta asincrona all'url indicata dall'attribute data-url
            // Nota:
            //  il backend si deve occupare di validare il token del recaptcha
            //  facendo una chiamata a google ed elaborandone il response (success + score)
            //  restituendo qui il risultato sottoforma di "success" booleano.
            // (vedi https://developers.google.com/recaptcha/docs/v3)
            formData.append('recaptchaToken', token);
            const formUrl = $form.attr('data-url');

            $form.find('.show-success').removeClass('show-success');
            $form.find('.show-error').removeClass('show-error');

            $.ajax({
              method: formMethod,
              url: formUrl,
              contentType: false,
              data: formData,
              processData: false,
            }).done((result) => {
              if (result.success) {
                $form.find('.form-msg .success-text').addClass('show-success');
              } else {
                $form.find('.form-msg .error-text').addClass('show-error');
              }
            }).fail(() => {
              $form.find('.form-msg .error-text').addClass('show-error');
            });
          });
        });
      });
    }
  }

  _inputFileLoad($instanceEl) {
    let file = $instanceEl.find('#contact_cv');

    file.on('change', (e) => {
      // Get the selected file
      [file] = e.target.files;
      // Get the file name and size
      const { name: fileName } = file;
      // Set the text content
      const fileNameAndSize = `${fileName}`;
      const svgFile = $('<svg role="img" class="svg-icon svg-icon--social-share" title="social-share"><use xlink:href="#sprite-social-share"></use></svg>');
      const fileEl = $('<p></p>');

      fileEl.append(svgFile).append(fileNameAndSize);
      $('.loaded-file').html(fileEl);
    });
  }

  _initSingleInstance($instanceEl) {
    const self = this;

    if ($instanceEl.find('[data-bg-column]')) {
      self._addBgColor($instanceEl);
    }
  }

  _addBgColor($instanceEl) {
    const isBgLeft = $instanceEl.find('[data-bg-column]').hasClass('text__left-col');
    const bgColor = $instanceEl.find('[data-bg-column]').data('bg-column');
    const $divBgColor = isBgLeft ? $('<div class="text__bg-left"></div>') : $('<div class="text__bg-right"></div>');

    // add overflow-x hidden to the body to avoid the horizontal scrollbar
    $('body').addClass('text__overflow-bg');

    $divBgColor.css('background-color', bgColor);

    if (isBgLeft) {
      $instanceEl.find('.text__left-col').prepend($divBgColor);
    } else {
      $instanceEl.find('.text__right-col').prepend($divBgColor);
    }
  }

  _initFormFocus($instanceEl) {
    const $inputs = $instanceEl.find('#formModalContact input');

    $inputs.on('mousedown', function () {
      $(this).addClass('click-hide-focus');
    });

    $inputs.on('blur', function () {
      $(this).removeClass('click-hide-focus');
    });
  }
}
